module.exports = __webpack_public_path__ + "img/packages.b00c893c.svg";